/* global googletag */

// Set lotame related keys
const PANORAMA_ID_KEY = 'panoramaId';
const IS_SUBSCRIBER_KEY = 'isSubscriber';

// Ensure googletag is defined
window.googletag = window.googletag || {};
window.googletag.cmd = window.googletag.cmd || [];

// Additional keys for lotame
const audTargetingKey = 'lotame';
const panoramaIdTargetingKey = 'lpanoramaid';
const lotameClientId = '17464';
const audLocalStorageKey = `lotame_${lotameClientId}_auds`;

/**
 * Callback when targeting audience is ready to push latest audience data
 *
 * @param $profile string
 *
 * @returns {void}
 */
const audienceReadyCallback = (profile) => {
  // Get audiences as an array
  const lotameAudiences = profile.getAudiences() || [];

  // Set the new target audiences for call to Google
  googletag.cmd.push(() => {
    window.googletag.pubads().setTargeting(audTargetingKey, lotameAudiences);
  });

  // Get the PanoramaID to set at Google
  const lotamePanoramaID = profile.getPanoramaId() || '';
  if (lotamePanoramaID) {
    googletag.cmd.push(() => {
      window.googletag.pubads().setTargeting(panoramaIdTargetingKey, lotamePanoramaID);
    });
  }
};

/**
 * Initialise Lotame config and tracking.
 *
 * @returns {void}
 */
const initialiseLotame = () => {
  // Immediately load audiences and Panorama ID from local storage
  try {
    const storedAuds = window.localStorage.getItem(audLocalStorageKey) || '';
    if (storedAuds) {
      googletag.cmd.push(() => {
        window.googletag.pubads().setTargeting(audTargetingKey, storedAuds.split(','));
      });
    }

    const localStoragePanoramaID = window.localStorage.getItem(PANORAMA_ID_KEY) || '';
    if (localStoragePanoramaID) {
      googletag.cmd.push(() => {
        window.googletag.pubads().setTargeting(panoramaIdTargetingKey, localStoragePanoramaID);
      });
    }
  } catch (e) {
    /* eslint-disable no-console */
    console.error(`Error with lotame local storage `, e);
  }

  // Lotame Config
  const lotameTagInput = {
    data: {},
    config: {
      clientId: Number(lotameClientId),
      audienceLocalStorage: audLocalStorageKey,
      onProfileReady: audienceReadyCallback,
    },
  };

  // Lotame initialization
  const lotameConfig = lotameTagInput.config || {};
  window[`lotame_${lotameClientId}`] = {};
  const namespace = window[`lotame_${lotameClientId}`];
  namespace.config = lotameConfig;
  namespace.data = lotameTagInput.data || {};
  namespace.cmd = namespace.cmd || [];
};

initialiseLotame();

window.addEventListener('load', () => {
  window[`lotame_${lotameClientId}`].cmd.push(() => {
    const tpInstance = window.tp || [];
    if (tpInstance.user?.isUserValid?.()) {
      // User logged-in
      const isSubscribe = sessionStorage.getItem(IS_SUBSCRIBER_KEY);
      if (isSubscribe) {
        // User subscribed
        window[`lotame_${lotameClientId}`].collect?.({
          behaviors: {
            int: ['Track Paywall Users'],
            act: ['Track Paywall Users'],
          },
        });
      } else {
        // Not user subscribed
        window[`lotame_${lotameClientId}`].collect?.({
          behaviors: {
            int: ['Datawall Subscribers'],
            act: ['Datawall Subscribers'],
          },
        });
      }
    }
  });
});
